import React from 'react';
import {Avatar, Dropdown} from 'antd';
import {UserOutlined, LogoutOutlined} from '@ant-design/icons';

// Avatar + dropdown (Profile, Logout). Caller supplies onLogout — the click
// handler is intentionally not in shared because each app may call its own
// /auth/logout endpoint or do additional cleanup.

function UserMenu({user, onLogout, extraItems}) {
    if (!user) return null;

    const items = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: user.display_name || user.email,
            disabled: true,
        },
        ...(extraItems && extraItems.length ? [{type: 'divider'}, ...extraItems] : []),
        {type: 'divider'},
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Sign out',
            onClick: onLogout,
        },
    ];

    return (
        <Dropdown menu={{items}} placement="bottomRight" trigger={['click']}>
            <Avatar
                src={user.avatar_url || undefined}
                icon={!user.avatar_url ? <UserOutlined /> : undefined}
                style={{cursor: 'pointer'}}
            />
        </Dropdown>
    );
}

export default UserMenu;
